/* * @Author: knight * @Title: 包含翻页列表组件 * @Date: 2020-04-08 17:52:09 *
@Last Modified by: knight * @Last Modified time: 2020-05-21 11:27:03 */
<template>
  <div :class="{ content: true, transform: transform }" v-if="resource.length">
    <div class="block-title">{{ title }}</div>

    <div class="block-list">
      <ListSlider
        slide-type="click"
        :length="resource.length"
        :hasSlider="resource.length > showItemNumber"
        :skew="skew"
        @clickpre="delIndex"
        @clicknext="addIndex"
      >
        <BlockAreaItem
          ref="blockAreaItem"
          :resource="resource"
          :resourceId="resourceId"
          v-if="!transform || resource.length >= 6"
          :transform="transform"
          :row="row"
          :spmidfrom="spmidfrom"
        />
        <!-- 新课推荐  小于5个数目 -->
        <NewLessonItem
          ref="blockAreaItem"
          :resource="resource"
          :resourceId="resourceId"
          :spmidfrom="spmidfrom"
          v-else
        />

        <template v-slot:slider-control>
          <div class="block-page-progress">{{ currentProgress }}</div>
        </template>
      </ListSlider>
    </div>
  </div>
</template>
<script>
import ListSlider from 'g-public/components/ListSlider'
import BlockAreaItem from './BlockAreaItem'
import NewLessonItem from './NewLessonItem'

export default {
  props: {
    spmidfrom: {
      required: true,
      type: String,
    },

    title: {
      required: true,
    },
    resource: {
      type: Array,
      required: true,
    },
    resourceId: {
      type: String | Number,
      // required: true
    },

    // 是否变形 给新课推荐小于6个课程数 第一个样式变化使用
    transform: {
      type: Boolean,
      default: false,
    },

    row: {
      type: String,
    },

    skew: {
      type: Number,
      default: -10,
    },
  },
  components: {
    ListSlider,
    BlockAreaItem,
    NewLessonItem,
  },
  data() {
    return {
      index: 1,
      showItemNumber: 6,
      // resizeHandler: null,
      // 展示的行数
      wrap: 1,
      resizeThrottleHandler: null,
    }
  },

  computed: {
    maxPage() {
      return Math.ceil(this.resource.length / this.showItemNumber)
    },

    currentProgress() {
      return `${this.index}/${this.maxPage}`
    },
  },

  watch: {
    // 新课推荐 / 精选推荐 后来赋值会触发
    resource(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.getWrap()
        this.resizeHandler()
      }
    },
  },

  mounted() {
    this.getWrap()
    this.resizeHandler()
    this.resizeThrottleHandler = window.funcThrottle(
        16,
        false,
        this.resizeHandler,
    )
    window.addEventListener('resize', this.resizeThrottleHandler, false)
  },

  destroyed() {
    window.removeEventListener('resize', this.resizeThrottleHandler)
    this.resizeThrottleHandler = null
  },

  methods: {
    addIndex() {
      if (this.index + 1 > this.maxPage) return
      this.index++
    },
    delIndex() {
      if (this.index - 1 < 1) return
      this.index--
    },
    // transform时 超过5个就要换行
    // 其余超过12个为两行
    getWrap() {
      if (this.transform) {
        this.wrap = this.resource.length < 6 ? 1 : 2
      } else {
        if (this.row) this.wrap = 1
        else this.wrap = this.resource.length > 12 ? 2 : 1
      }
    },

    resizeHandler() {
      let maxWidth
      let currentNumber

      this.getWrap()
      this.index = 1

      // 异步 解决推荐课程 精选推荐 获取数据时还获取不到目标元素
      this.$nextTick(() => {
        const $el = this.$refs.blockAreaItem && this.$refs.blockAreaItem.$el
        if (!$el) return
        maxWidth = $el.offsetWidth

        if (this.transform) {
          if (this.resource.length < 6) {
            currentNumber = Math.ceil((maxWidth / 854) * this.wrap)
          } else {
            currentNumber = Math.ceil((maxWidth / 216) * this.wrap)
          }
        } else {
          currentNumber = Math.ceil((maxWidth / 216) * this.wrap)
        }
        this.showItemNumber = currentNumber
      })
    },
  },
}
</script>

<style lang="less" scoped>
// .ell {
//     white-space: nowrap;
//     overflow: hidden;
//     text-overflow: ellipsis;
// }

.block-list {
  &.transform {
    width: 864px;
  }
}

.content {
  margin-bottom: 20px;
  // width: 1296px;
}

.block-title {
  font-size: 20px;
  color: #212121;
  letter-spacing: 0;
  line-height: 28px;
  margin-bottom: 20px;
  padding-top: 20px;
}

.block-page-progress {
  width: 48px;
  text-align: center;
  color: #212121;
  line-height: 16px;
  margin: 0 26px;
  letter-spacing: 2px;
}

@media screen and (max-width: 1438px) {
  // .content {
  //     width: auto;
  // }

  // .content {
  //                     width: 1070px;
  // }

  .content.transform {
    .block-list {
      width: auto;
    }
  }
}
</style>
